import { Controller } from '@hotwired/stimulus'
import Cookies from 'js-cookie'
import { fadeOut } from '../utilities/animations'

export default class extends Controller {
  connect () {
    this.cookieName = 'cookie_usage_acknowledged'
    const cookie = Cookies.get(this.cookieName)
    if (cookie) {
      this.element.remove()
    } else {
      this.element.classList.toggle('display-block')
    }
  }

  accept () {
    Cookies.set(this.cookieName, true, { expires: 365 })
    this.dismissBanner()
  }

  dismissBanner () {
    fadeOut(this.element, true)
  }
}
